import { render, staticRenderFns } from "./BatchCreate.vue?vue&type=template&id=5fefc3d2&scoped=true"
import script from "./BatchCreate.vue?vue&type=script&lang=js"
export * from "./BatchCreate.vue?vue&type=script&lang=js"
import style0 from "./BatchCreate.vue?vue&type=style&index=0&id=5fefc3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fefc3d2",
  null
  
)

export default component.exports